import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlertIcon, XIcon } from 'lucide-react';
import { useAuth } from '../services/contexts/authContext';
import { URLS } from '../router-x/routes';

const ImpersonationBanner = () => {
	const { isImpersonating, impersonationTarget, stopImpersonation } = useAuth();
	const navigate = useNavigate();
	const [stopping, setStopping] = React.useState(false);

	if (!isImpersonating) return null;

	const handleStop = async () => {
		try {
			setStopping(true);
			const returnPath = await stopImpersonation();
			// Navigate back to the customer detail page if available, else admin root
			navigate(returnPath || URLS.ADMIN.ROOT);
		} catch (err) {
			console.error('Failed to stop impersonation:', err);
		} finally {
			setStopping(false);
		}
	};

	return (
		<div className="sticky top-0 z-[9999] bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2.5 flex items-center justify-between shadow-md">
			<div className="flex items-center gap-2.5">
				<ShieldAlertIcon size={18} className="flex-shrink-0" />
				<span className="text-sm font-medium">
					Viewing as: <strong>{impersonationTarget?.name || 'User'}</strong>
					<span className="hidden sm:inline opacity-80 ml-1.5">
						({impersonationTarget?.email})
					</span>
				</span>
			</div>
			<button
				onClick={handleStop}
				disabled={stopping}
				className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
			>
				<XIcon size={14} />
				<span>{stopping ? 'Restoring...' : 'Stop Impersonation'}</span>
			</button>
		</div>
	);
};

export default ImpersonationBanner;
